import { List } from 'immutable';
import { isEmpty } from 'lodash';

export function itemsIntersect(arr1, arr2) {
  const stringArray1 = arr1.map(String);
  const stringArray2 = arr2.map(String);

  return stringArray1.some((value) => stringArray2.includes(value));
}

export const filterConnectedTickets = (event, showAttendeeInputsPerTicket, ticketsInCart, ticketId) =>
  (event.get('questions') || List()).toJS().filter((question) => {
    const connectedTicketIds = question.connected_ticket_ids || [];
    if (isEmpty(connectedTicketIds)) return true;
    // if ticket in cart has 2 and we are attendee number three then omot that ticket
    if (showAttendeeInputsPerTicket) {
      return connectedTicketIds.includes(ticketId);
    }
    return itemsIntersect(connectedTicketIds, ticketsInCart);
  });

// Constants for disabled ticket states
export const DISABLED_TICKET_STATES = ['soldout', 'cancelled', 'postponed', 'sale-ended', 'sale-not-started', 'unavailable'];

/**
 * Check if a ticket is available for purchase
 * @param {Object} ticket - Immutable ticket object
 * @returns {boolean} - true if ticket is available, false otherwise
 */
export const isTicketAvailable = (ticket) => {
  if (!ticket) return false;

  const status = ticket.get('status');
  const quantityTotal = ticket.get('quantity_total');
  const quantitySold = ticket.get('quantity_sold');
  const availableQuantity = ticket.get('available_quantity');

  // Check if ticket status is disabled
  if (DISABLED_TICKET_STATES.includes(status)) {
    return false;
  }

  // Check if ticket is oversold or has no remaining capacity
  if (quantityTotal < quantitySold || availableQuantity <= 0) {
    return false;
  }

  return true;
};

/**
 * Check if the cart has at least one available ticket
 * @param {Object} cart - Cart object with ticketId as keys
 * @param {List} tickets - Immutable List of ticket objects
 * @returns {boolean} - true if at least one ticket in cart is available
 */
export const hasAvailableTicketsInCart = (cart, tickets) => {
  if (isEmpty(cart) || !tickets || tickets.size === 0) {
    return false;
  }

  const cartTicketIds = Object.keys(cart).filter((id) => cart[id] > 0);

  // Check if at least one ticket in cart is available for purchase
  return cartTicketIds.some((ticketId) => {
    const ticket = tickets.find((t) => t.get('id').toString() === ticketId.toString());
    return ticket && isTicketAvailable(ticket);
  });
};
